// extracted by mini-css-extract-plugin
module.exports = {"promoNavButtons":"PromotionArrows-module_promoNavButtons_2RcXwTjN4I","next":"PromotionArrows-module_next_3TouSdd05C","previous":"PromotionArrows-module_previous_245c1H7gFk"};